<template>
  <img
    :src="image"
    :alt="alt"
    class="img-fluid"
    v-bind="$attrs"
    @load="onLoad && onLoad()"
  />
</template>

<script setup lang="ts">
defineOptions({
  name: 'lp-guided-tour-step-image',
})

defineProps<{
  image?: string
  alt?: string
  onLoad?: () => void
}>()
</script>
